/**
 * Hardcoded benchmark items for reading fluency (customData.readingFluency).
 *
 * Add another object to this array to show a new teacher field + parent sentence
 * for those grades × that subject. No other files need to change.
 *
 * Example — Math Fluency for 4th–6th:
 *
 * {
 *   id: "math-fluency",
 *   label: "Math Fluency",
 *   subject: "Math",
 *   subjectAliases: ["MATHEMATICS"],
 *   inputLabel: "Current score",
 *   placeholder: "e.g. 24",
 *   unit: "correct",
 *   maxLength: 3,
 *   digitsOnly: true,
 *   teacherGuidance: "Enter each student's current score. Not shown to families.",
 *   parentResultLabel: "Your student",
 *   parentValue: (value) => `${value}`,
 *   grades: {
 *     FOURTH: { stem: "The fourth-grade math fluency benchmark is …" },
 *     FIFTH: { stem: "The fifth-grade math fluency benchmark is …" },
 *     SIXTH: { stem: "The sixth-grade math fluency benchmark is …" }
 *   }
 * }
 */
export const BENCHMARK_ITEMS = [
    {
        id: "ela-reading-fluency",
        label: "Reading Fluency",
        subject: "ELA",
        subjectAliases: ["READING, WRITING, AND COMMUNICATING"],
        inputLabel: "Current WPM",
        placeholder: "",
        unit: "words per minute",
        maxLength: 3,
        digitsOnly: true,
        teacherGuidance:
            "Fill in each student's current fluency rate (words per minute). Families see the grade-level benchmark and this number; they do not see this note.",
        parentResultLabel: "Your student's current fluency rate:",
        parentValue: (value) => `${value} words per minute`,
        grades: {
            FIRST: {
                stem: "The first-grade fluency benchmark is to read a minimum of 53 words per minute in the spring with fluency."
            },
            SECOND: {
                stem: "The second-grade fluency benchmark is to read a minimum of 89 words per minute in the spring with fluency."
            },
            THIRD: {
                stem: "The third-grade fluency benchmark is to read a minimum of 107 words per minute in the spring with fluency."
            }
        }
    }
];
